import {JobCareerConvertResponse} from "../../infra/api/service/job_career_api_convert";
import {Occupation} from "./project";
import {FrontDate} from "./frontDate";

export enum EmploymentStatus {
    EmploymentStatus_Unknown = 0,
    // 正社員
    EmploymentStatus_FullTime = 1,
    // 業務委託
    EmploymentStatus_Subcontracting = 2,
    // その他
    EmploymentStatus_Other = 3,
    // 役員
    EmploymentStatus_BoardMember = 4,
    // 個人事業主
    EmploymentStatus_SoleProprietorship = 5
}

export class JobCareer {

    public static from(from: JobCareerConvertResponse): JobCareer {
        return new JobCareer(
            from.id,
            from.customerID,
            from.companyName,
            from.description,
            from.occupations,
            from.startedAt,
            from.endedAt,
            from.post,
            from.employmentStatus,
        )
    }

    constructor(public readonly id: string,
                public readonly customerID: string,
                public readonly companyName: string,
                public readonly description: string,
                // 職種
                public readonly occupations: Occupation[],
                public readonly startedAt: FrontDate,
                public readonly endedAt: FrontDate,
                public readonly post: string,
                // 雇用形態
                public employmentStatus: EmploymentStatus,
    ) {
    }

    public getStartedAtString(): string {
        const year = this.startedAt.year ? `${this.startedAt.year}年` : "";
        const month = this.startedAt.month ? `${this.startedAt.month}月` : "";
        // YYYY年MM月
        return `${year}${month}`;
    };

    public getEndedAtString(): string {
        const year = this.endedAt.year ? `${this.endedAt.year}年` : "";
        const month = this.endedAt.month ? `${this.endedAt.month}月` : "";

        return ((this.endedAt.year === "") && (this.endedAt.month === ""))
            ? `在職中`
            : `${year}${month}`;
    };

}





// WEBPACK FOOTER //
// ./src/domain/model/job_career.ts